import script from "./ShopView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopView.vue?vue&type=script&lang=ts&setup=true"

import "./ShopView.vue?vue&type=style&index=0&id=a97c516e&lang=scss"

const __exports__ = script;

export default __exports__